<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-5 px-7">
    <div class="header">
      <h1 class="title">{{ $t(template.militaryTitle) }}</h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideMilitary"></p>
    </div>
    <div class="body">
      <v-form ref="form">
        <v-row>
          <v-col cols="12" class="col-md-6">
            <!-- 전역여부 -->
            <v-col class="mt-n4">
              <v-radio-group
                v-model="mYn"
                row
                hide-details="auto"
                :rules="[v => !!v || '필수 정보입니다.']"
                @change="mtypeset"
                :readonly="isReadonly"
              >
                <span class="col-4 py-0">{{ itemLabel('militaryYn') }}</span>
                <i-radio
                  label="필"
                  value="Y"
                  class="col-3  py-0 mr-0"
                ></i-radio>
                <i-radio
                  label="미필(면제/비대상)"
                  value="N"
                  class="col-5 py-0 mr-0"
                ></i-radio>
              </v-radio-group>
            </v-col>
          </v-col>
          <v-col cols="12" class="col-md-3" :class="colclass">
            <!-- 입대일 -->
            <CommonDatePicker
              :readonly="isReadonly"
              :label="itemLabel('militarySdate')"
              useMaxCurrentDate
              @change="save"
              :rules="[rules.required('militarySdate')]"
              v-model="militaryStartDate"
              :disabled="!mpass"
              :type="militaryTermFormat === 'YYYY.MM' ? 'month' : 'date'"
            />
          </v-col>
          <v-col cols="12" class="col-md-3" :class="colclass">
            <!-- 전역일 -->
            <CommonDatePicker
              :readonly="isReadonly"
              :label="itemLabel('militaryEdate')"
              @change="save"
              :rules="[rules.required('militaryEdate')]"
              v-model="militaryEndDate"
              :min="militaryStartDate"
              :disabled="!mpass"
              :type="militaryTermFormat === 'YYYY.MM' ? 'month' : 'date'"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="military === 'A' || military === 'B' || military === 'C'"
          class="mt-2"
        >
          <v-col
            cols="12"
            v-if="military === 'A' || military === 'B'"
            :class="[collength, colclass]"
          >
            <!-- 전역구분 -->
            <DirectInputSelect
              v-maxlength="'military_kind'"
              :useDirect="itemDirectInput('militaryKind')"
              v-model="mkind"
              :items="militaryKindItems"
              :label="itemLabel('militaryKind')"
              outlined
              dense
              hide-details="auto"
              :rules="[
                rules.required('militaryKind'),
                rules.maxlength('militaryKind'),
              ]"
              @change="save"
              :class="[leftRoundedClass]"
              :readonly="isReadonly"
              :disabled="isReadonly"
            />
          </v-col>
          <v-col cols="12" :class="[collength, colclass]">
            <!-- 군별 -->
            <DirectInputSelect
              :useDirect="itemDirectInput('militaryType')"
              v-model="mtype"
              :items="itemArray('militaryType')"
              v-maxlength="'military_type'"
              :label="itemLabel('militaryType')"
              outlined
              dense
              hide-details="auto"
              :rules="
                !mpass
                  ? []
                  : [
                      rules.required('militaryType'),
                      rules.maxlength('militaryType'),
                    ]
              "
              @change="save"
              :class="[zeroRoundedClass]"
              :readonly="isReadonly"
              :disabled="!mpass"
            />
          </v-col>
          <v-col cols="12" :class="[collength, colclass]">
            <!-- 병과 -->
            <DirectInputSelect
              v-model="mclass"
              v-maxlength="'military_class'"
              :useDirect="itemDirectInput('militaryClass')"
              :label="itemLabel('militaryClass')"
              outlined
              :items="itemArray('militaryClass')"
              dense
              hide-details="auto"
              @change="save"
              :rules="
                !mpass
                  ? []
                  : [
                      rules.required('militaryClass'),
                      rules.maxlength('militaryClass'),
                    ]
              "
              :class="[rightRoundedClass]"
              :readonly="isReadonly"
              :disabled="!mpass"
            ></DirectInputSelect>
          </v-col>
        </v-row>
        <v-row v-if="military != 'E'" class="mt-2">
          <v-col
            cols="12"
            v-if="military === 'A' || military === 'B' || military === 'C'"
            :class="[collength2, colclass]"
          >
            <DirectInputSelect
              :useDirect="itemDirectInput('militaryLevel')"
              v-model="mlevel"
              v-maxlength="'military_level'"
              :items="itemArray('militaryLevel')"
              :label="itemLabel('militaryLevel')"
              outlined
              dense
              hide-details="auto"
              :rules="
                !mpass
                  ? []
                  : [
                      rules.required('militaryLevel'),
                      rules.maxlength('militaryLevel'),
                    ]
              "
              @change="save"
              :class="leftRoundedClass"
              :readonly="isReadonly"
              :disabled="!mpass"
            />
          </v-col>
          <v-col cols="12" :class="[collength2, colclass]" v-else>
            <DirectInputSelect
              :useDirect="itemDirectInput('militaryKind')"
              v-model="mkind"
              :items="militaryKindItems"
              :label="itemLabel('militaryKind')"
              outlined
              dense
              v-maxlength="'military_kind'"
              hide-details="auto"
              :rules="[
                rules.required('militaryKind'),
                rules.maxlength('militaryKind'),
              ]"
              @change="save"
              :readonly="isReadonly"
              :class="leftRoundedClass"
              :disabled="isReadonly"
            />
          </v-col>
          <v-col
            cols="12"
            :class="[collength2, colclass]"
            v-if="military === 'A'"
          >
            <i-text-field
              v-maxlength="'military_number'"
              v-model="mnumber"
              :items="itemArray('militaryNumber')"
              :label="itemLabel('militaryNumber')"
              outlined
              dense
              hide-details="auto"
              :rules="
                !mpass
                  ? []
                  : [
                      rules.required('militaryNumber'),
                      rules.maxlength('militaryNumber'),
                    ]
              "
              @change="save"
              :readonly="isReadonly"
              :class="zeroRoundedClass"
              :disabled="!mpass"
            ></i-text-field>
          </v-col>
          <v-col cols="12" :class="[collength2, colclass]">
            <!-- 면제사유 -->
            <i-text-field
              v-maxlength="'military_reason'"
              v-model="mreason"
              :label="itemLabel('militaryReason')"
              outlined
              dense
              hide-details="auto"
              :rules="
                mpass
                  ? []
                  : [
                      rules.required('militaryReason'),
                      rules.maxlength('militaryReason'),
                    ]
              "
              @blur="save"
              :class="[rightRoundedClass]"
              :readonly="isReadonly"
              :disabled="mpass"
            ></i-text-field>
          </v-col>
        </v-row>
        <v-row v-else class="mt-2">
          <v-col cols="12" :class="colclass">
            <i-text-field
              v-maxlength="'military_reason'"
              v-model="mreason"
              :label="itemLabel('militaryReason')"
              outlined
              dense
              hide-details="auto"
              :rules="
                mpass
                  ? []
                  : [
                      rules.required('militaryReason'),
                      rules.maxlength('militaryReason'),
                    ]
              "
              @blur="save"
              :readonly="isReadonly"
              :disabled="mpass"
              :class="[rightRoundedClass]"
            ></i-text-field>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mdiCalendarBlank } from '@mdi/js';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import DirectInputSelect from '@/components/common/DirectInputSelect.vue';
import { snack } from '@/plugins/dialog/api';
export default {
  props: {
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemLabel: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  components: { CommonDatePicker, DirectInputSelect },
  computed: {
    mpass() {
      return this.isReadonly ? this.isReadonly : this.mYn === 'Y';
    },
    militaryKindItems() {
      const items = this.itemArray('militaryKind') || [];
      const exemptItems = ['면제', '미필'];
      return this.mYn === 'N'
        ? items.filter(item => exemptItems.includes(item))
        : items.filter(item => !exemptItems.includes(item));
    },
    collength: function() {
      return {
        'col-md-4':
          this.military === 'A' ||
          this.military === 'B' ||
          this.military === 'D',
        'col-md-6': this.military === 'C' || this.military === 'E',
      };
    },
    collength2: function() {
      return {
        'col-md-4': this.military === 'A',
        'col-md-6': this.military !== 'A',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
  }, //계산

  mounted() {
    this.setting();
  },
  data: () => ({
    mdiCalendarBlank,
    itemDelimeter: '#',
    military: '',
    mYn: '',
    mkind: '',
    mtype: '',
    mclass: '',
    mlevel: '',
    mnumber: '',
    mreason: '',
    start: '',
    end: '',
    militaryStartDate: '',
    militaryEndDate: '',
    militaryTermFormat: '',
    alert: false,
  }),
  methods: {
    setting: function() {
      if (this.template.typeMilitary)
        this.military = this.template.typeMilitary;

      if (this.opts) {
        let $this = this;
        for (let key in this.opts) {
          let prop = this.opts[key];

          if (
            prop.id.cvColumn === 'militarySdate' ||
            prop.id.cvColumn === 'militaryEdate'
          ) {
            $this.militaryTermFormat = prop.oFormat;
          }
        }
      }

      this.dataSetting();
    },
    dataSetting: function() {
      if (this.info && this.info.military) {
        this.mYn = this.info.military.militaryYn;
        this.mkind = this.info.military.militaryKind;
        this.mtype = this.info.military.militaryType;
        this.mreason = this.info.military.militaryReason;
        this.mclass = this.info.military.militaryClass;
        this.mnumber = this.info.military.militaryNumber;
        this.mlevel = this.info.military.militaryLevel;

        var date = '';
        if (this.info.military.militarySdate) {
          if (this.militaryTermFormat === 'YYYY.MM.DD') {
            date =
              this.info.military.militarySdate.substring(0, 4) +
              '-' +
              this.info.military.militarySdate.substring(4, 6) +
              '-' +
              this.info.military.militarySdate.substring(6, 8);
          } else if (this.militaryTermFormat === 'YYYY.MM') {
            date =
              this.info.military.militarySdate.substring(0, 4) +
              '-' +
              this.info.military.militarySdate.substring(4, 6);
          }

          this.militaryStartDate = date;
        }

        if (this.info.military.militaryEdate) {
          if (this.militaryTermFormat === 'YYYY.MM.DD') {
            date =
              this.info.military.militaryEdate.substring(0, 4) +
              '-' +
              this.info.military.militaryEdate.substring(4, 6) +
              '-' +
              this.info.military.militaryEdate.substring(6, 8);
          } else if (this.militaryTermFormat === 'YYYY.MM') {
            date =
              this.info.military.militaryEdate.substring(0, 4) +
              '-' +
              this.info.military.militaryEdate.substring(4, 6);
          }

          this.militaryEndDate = date;
        }
      }
    },

    mtypeset: function() {
      // 전역구분 선택지는 전역여부에 따라 달라지므로 전환 시 항상 초기화
      this.mkind = '';
      if (this.mYn === 'N') {
        this.mtype = '';
        this.mclass = '';
        this.mlevel = '';
        this.mnumber = '';
        this.mreason = '';
        this.militaryStartDate = '';
        this.militaryEndDate = '';
      } else {
        this.mreason = '';
      }

      this.save();
    },

    valid() {
      return this.$refs.form.validate();
    },
    async save() {
      await this.$nextTick();

      const id = {
        annoId: this.$route.params.annoId,
      };
      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      var stdate = this.militaryStartDate?.replace(pattern, '') || '';
      var eddate = this.militaryEndDate?.replace(pattern, '') || '';

      const p = {
        id: id,
        militaryYn: this.mYn,
        militaryClass: this.mclass,
        militarySdate: stdate,
        militaryEdate: eddate,
        militaryKind: this.mkind,
        militaryLevel: this.mlevel,
        militaryNumber: this.mnumber,
        militaryReason: this.mreason,
        militaryType: this.mtype,
      };

      this.$emit('save', p, 'military');
    },
    savecallback: function(res) {
      if (res.status !== 200) {
        console.log('MILITARY SAVE FAIL');
      } else snack.info(`${this.template.militaryTitle}이 저장 되었습니다.`);
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
